module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-index-fill-4bcc86b5.svg";